import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me')
};

// Contact API
export const contactAPI = {
  submit: (data) => api.post('/contact', data),
  getAll: () => api.get('/admin/contacts'),
  delete: (id) => api.delete(`/admin/contact/${id}`)
};

// Content API
export const contentAPI = {
  getAll: () => api.get('/content'),
  update: (section, data) => api.put(`/content/${section}`, data)
};

// Settings API
export const settingsAPI = {
  getAll: () => api.get('/settings'),
  update: (key, value) => api.put('/settings', { key, value }),
  trackWhatsAppClick: (page, message) => api.post('/settings/whatsapp-click', { page, message }),
  getWhatsAppAnalytics: () => api.get('/settings/whatsapp-analytics')
};

export default api;
